// 弱提示弹窗
import React, { useEffect, memo } from 'react';
import { once, autoClick } from '../../utils/tools';
import { WithErrorHandler } from '../WithErrorHandler';
var timer;
export var Prompt = function (props) {
    var clearTimer = function () {
        // 清除倒计时
        if (timer) {
            clearTimeout(timer);
        }
    };
    var showFun = function () {
        // 显示
        if (typeof props.closingTime != 'undefined') {
            timer = setTimeout(function () {
                autoClick();
            }, props.closingTime * 1000);
        }
        // 点击任意区域 隐藏若提示
        setTimeout(function () {
            once(document, 'click', function () {
                if (props.show) {
                    clearTimer();
                    if (typeof props.closeFun != 'undefined' &&
                        Object.prototype.toString
                            .apply(props.closeFun)
                            .toLocaleLowerCase()
                            .indexOf('function') != -1) {
                        props.closeFun();
                    }
                }
            });
        }, 100);
    };
    useEffect(function () {
        clearTimer();
        if (props.show) {
            showFun();
        }
        return function () {
            clearTimer();
        };
    }, [props.show]);
    return (React.createElement("div", { className: "newcar_ui_prompt " + props.cn + " " + (props.show ? 'newcar_ui_showPrompt' : '') }, props.tipStr));
};
Prompt.defaultProps = {
    show: false,
    tipStr: '',
    cn: '',
    closingTime: 3,
    // eslint-disable-next-line no-empty-function
    closeFun: function () { }
};
export default WithErrorHandler(memo(Prompt));
